/**
 * @file
 * @prettier
 */

function clearHash() {
  if (location.hash.length > 0) {
    location.hash = "";
  }
}

export function InitializeDLFaQsFAQsPage() {
  clearHash();
}
